@if (poptionals.length > 0 && adding) {
  <div class="main-container">
    <app-poptionals [poptionals]="poptionals" (onDone)="done($event)" (onCancel)="adding = false" [itemQty]="item.quantity"></app-poptionals>
  </div>
}
@if (!adding) {
  <div class="main-container">
    <div class="prod-name">
      {{product.delivery_name || product.name}} {{product.price | currency:'BRL'}}
    </div>
    <div class="prod-image">
      <img [src]="product.aws_picture_path || (serverUrl + product.picture_path.url) || (serverUrl + '/default.png')"/>
    </div>
    <div class="prod-desc">{{product.description}}</div>
    <div class="qty">
      <div class="qty-lbl">Quantidade: &nbsp; &nbsp;</div>
      <div class="qty-buttons">
        <div class="input-group">
          <div class="input-group-prepend">
            <button class="btn btn-md btn-minus"
              (click)="item.quantity = item.quantity - 1"
              [disabled]="item.quantity == 1">
              <fa-icon [icon]="faMinus"></fa-icon>
            </button>
          </div>
          <input type="number" class="form-control" [ngModel]="item.quantity" readonly/>
          <div class="input-group-append">
            <button class="btn btn-md btn-plus"
              (click)="item.quantity = item.quantity + 1">
              <fa-icon [icon]="faPlus"></fa-icon>
            </button>
          </div>
        </div>
      </div>
    </div>
    <hr/>
    <div class="prod-notes">
      <label>Observações:</label>
      <input type="text" class="form-control" [(ngModel)]="item.notes_obj[0].text"/>
    </div>
    <br/>
    <div class="action-buttons">
      <button class="btn btn-md btn-default back-btn" (click)="exit('button')">VOLTAR</button> &nbsp; &nbsp;
      <button class="btn btn-md btn-success" [disabled]="!poptionalsLoaded && !poptionalsLoadFailed" (click)="addProduct()">
        {{ !poptionalsLoaded && !poptionalsLoadFailed ? 'CARREGANDO...' : 'ADICIONAR' }}
      </button>
    </div>
  </div>
}